var _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Outline/Image 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1050_30619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 2.00037H21.9535V21.9543H2.00049V2.00037Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1050_30619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65149 3.50024C5.13049 3.50024 3.50049 5.22924 3.50049 7.90424V16.0502C3.50049 18.7262 5.13049 20.4542 7.65149 20.4542H16.2975C18.8225 20.4542 20.4535 18.7262 20.4535 16.0502V7.90424C20.4555 6.54124 20.0395 5.40324 19.2515 4.61424C18.5235 3.88524 17.5045 3.50024 16.3025 3.50024H7.65149ZM16.2975 21.9542H7.65149C4.27149 21.9542 2.00049 19.5812 2.00049 16.0502V7.90424C2.00049 4.37324 4.27149 2.00024 7.65149 2.00024H16.3025C17.9105 2.00024 19.2975 2.53724 20.3125 3.55424C21.3735 4.61624 21.9555 6.16124 21.9535 7.90524V16.0502C21.9535 19.5812 19.6805 21.9542 16.2975 21.9542Z",
    fill: "#722ED1"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85672 7.68976C8.25272 7.68976 7.76172 8.18076 7.76172 8.78576C7.76172 9.38976 8.25272 9.88076 8.85772 9.88076C9.46172 9.88076 9.95372 9.38976 9.95372 8.78676C9.95272 8.18176 9.46072 7.69076 8.85672 7.68976ZM8.85772 11.3808C7.42572 11.3808 6.26172 10.2168 6.26172 8.78576C6.26172 7.35376 7.42572 6.18976 8.85772 6.18976C10.2887 6.19076 11.4527 7.35476 11.4537 8.78476V8.78576C11.4537 10.2168 10.2897 11.3808 8.85772 11.3808Z",
    fill: "#722ED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74893 20.1116C3.62493 20.1116 3.49893 20.0806 3.38293 20.0156C3.02093 19.8126 2.89393 19.3556 3.09593 18.9946C3.15593 18.8866 4.59093 16.3496 6.16993 15.0496C7.42193 14.0196 8.76993 14.5856 9.85593 15.0426C10.4949 15.3116 11.0989 15.5656 11.6789 15.5656C12.2109 15.5656 12.8779 14.6256 13.4679 13.7966C14.2869 12.6406 15.2169 11.3326 16.5789 11.3326C18.7489 11.3326 20.6219 13.2686 21.6289 14.3086L21.7449 14.4286C22.0329 14.7256 22.0259 15.2006 21.7289 15.4896C21.4339 15.7786 20.9589 15.7716 20.6689 15.4736L20.5509 15.3516C19.6989 14.4706 18.1129 12.8326 16.5789 12.8326C15.9909 12.8326 15.3009 13.8056 14.6899 14.6646C13.8519 15.8446 12.9849 17.0656 11.6789 17.0656C10.7959 17.0656 9.98693 16.7256 9.27393 16.4246C8.13993 15.9466 7.62593 15.7936 7.12293 16.2076C5.75893 17.3316 4.41693 19.7056 4.40393 19.7286C4.26693 19.9736 4.01193 20.1116 3.74893 20.1116Z",
    fill: "#722ED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileImage);
export default __webpack_public_path__ + "static/media/icon-file-image.10c04134c9990b6886dcbe0439039975.svg";
export { ForwardRef as ReactComponent };